import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-progress-dialog',
    template: `
    @if (message) {
      <div mat-dialog-content>
        <app-progress
          [type]="message ? 'Bar' : 'Spinner'"
          [message]="message"
        ></app-progress>
      </div>
    }
    
    @if (!message) {
      <mat-spinner
        color="accent"
        diameter="40"
        mode="indeterminate"
      ></mat-spinner>
    }
    `,
    styles: [],
    standalone: false
})
export class ProgressDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public message: string) {}
}
